import {
	SIDE_NAV_LIGHT,
	NAV_TYPE_SIDE,
	DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "Contadash";
export const API_BASE_URL = env.API_ENDPOINT_URL;
/** Origem do backend sem `/api` — arquivos de `public/` (ex.: contadash.zip) ficam em `{BACKEND_PUBLIC_BASE_URL}/arquivo` */
export const BACKEND_PUBLIC_BASE_URL = String(API_BASE_URL).replace(/\/?api\/?$/i, "");
export const WORKER_ZIP_URL = `${BACKEND_PUBLIC_BASE_URL}/contadash.zip`;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";

export const PUBLIC_PREFIX_PATH = env.PUBLIC_PREFIX_PATH;

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: "pt",
	navType: NAV_TYPE_SIDE,
	topNavColor: "transparent",
	headerNavColor: "",
	mobileNav: false,
	currentTheme: "light",
	direction: DIR_LTR,
};
